"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageLevel = exports.ForegroundColorType = exports.TypographicalEmphasis = exports.RichPartMethodType = exports.MessagePartType = void 0;
var MessagePartType;
(function (MessagePartType) {
    MessagePartType["TEXT"] = "text";
    MessagePartType["DATE"] = "date";
    MessagePartType["LINK"] = "link";
    MessagePartType["RICH_TEXT"] = "rich_text";
})(MessagePartType = exports.MessagePartType || (exports.MessagePartType = {}));
var RichPartMethodType;
(function (RichPartMethodType) {
    RichPartMethodType["TYPOGRAPHICAL_EMPHASIS"] = "typographical_emphasis";
})(RichPartMethodType = exports.RichPartMethodType || (exports.RichPartMethodType = {}));
var TypographicalEmphasis;
(function (TypographicalEmphasis) {
    TypographicalEmphasis["BOLD"] = "bold";
    TypographicalEmphasis["ITALIC"] = "italic";
})(TypographicalEmphasis = exports.TypographicalEmphasis || (exports.TypographicalEmphasis = {}));
var ForegroundColorType;
(function (ForegroundColorType) {
    ForegroundColorType["WARN"] = "WARN";
})(ForegroundColorType = exports.ForegroundColorType || (exports.ForegroundColorType = {}));
var MessageLevel;
(function (MessageLevel) {
    MessageLevel["INFO"] = "info";
    MessageLevel["WARN"] = "warn";
})(MessageLevel = exports.MessageLevel || (exports.MessageLevel = {}));
//# sourceMappingURL=types.js.map